import { memo } from 'react';
import React, { type SVGProps, type FC } from 'react';

export const IconRight: FC<SVGProps<SVGSVGElement>> = memo((props) => (
    <svg
        width="20"
        height="33"
        viewBox="0 0 20 33"
        fill="#2281CC"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
            d="M20 28.74L7.63833 16.5L20 4.26L16.1943 0.5L0 16.5L16.1943 32.5L20 28.74Z"
            fill="#2281CC"
        />
    </svg>
));
